module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-450.0b3668a.woff2";